const API_URL = process.env.REACT_APP_API_URL;

const getAuthHeaders = () => {
  return {
    'Content-Type': 'application/json',
  };
};

// GET all records
export const getAll = async (apiName) => {
  const res = await fetch(`${API_URL}/${apiName}`, {
    headers: getAuthHeaders(),
    credentials: 'include',
  });
  if (!res.ok) throw new Error(`GET ${apiName} failed`);
  return res.json();
}

// GET one by id
export const getById = async (apiName, id) => {
  const res = await fetch(`${API_URL}/${apiName}/${id}`, {
    headers: getAuthHeaders(),
    credentials: 'include',
  });
  if (!res.ok) throw new Error(`GET ${apiName}/${id} failed`);
  return res.json();
};

// CREATE new record
export const create = async (apiName, data) => {
  const res = await fetch(`${API_URL}/${apiName}`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(data),
    credentials: 'include',
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(body.message || `POST ${apiName} failed`);
  return body;
};

// UPDATE existing record
export const update = async (apiName, id, data) => {
  const res = await fetch(`${API_URL}/${apiName}/${id}`, {
    method: 'PUT',
    headers: getAuthHeaders(),
    body: JSON.stringify(data),
    credentials: 'include',
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(body.message || `PUT ${apiName}/${id} failed`);
  return body;
};

// DELETE record
export const deleteOne = async (apiName, id) => {
  const res = await fetch(`${API_URL}/${apiName}/${id}`, {
    method: 'DELETE',
    headers: getAuthHeaders(),
    credentials: 'include',
  });
  if (!res.ok) throw new Error(`DELETE ${apiName}/${id} failed`);
  return res.json();
};
